module.exports = __webpack_public_path__ + "static/media/3-min.a85445f7.png";